import { CONFIG } from '../config.js';
/** Apply the cycling confidence lever to a duel's base points. */
function applyDuelConfidence(base, weight) {
    return CONFIG.CYCLING.CONFIDENCE_MODE === 'ADD' ? base + weight : base * weight;
}
/** The top weight on the ladder — the "banker" (used for the premium tiebreak). */
const TOP_WEIGHT = Math.max(...CONFIG.CYCLING.CONFIDENCE_WEIGHTS);
/**
 * Score a full cycling stage entry against the settled duels (spec mirror of
 * scoreEntry). Void duels — and any duel without a settlement — contribute 0 and
 * are excluded. Confidence multiplies each correct duel's base points. Pure and
 * idempotent.
 */
export function scoreCyclingEntry(entry, settlements) {
    let stageScore = 0;
    let correctDuels = 0;
    let topWeightHits = 0;
    const scoreByDuel = {};
    for (const pick of entry.picks) {
        const s = settlements.get(pick.duelId);
        if (!s || s.outcome === 'void')
            continue; // void duels excluded
        if (s.winner === pick.pick) {
            const pts = applyDuelConfidence(CONFIG.CYCLING.POINTS.duel, pick.confidenceWeight);
            scoreByDuel[pick.duelId] = pts;
            stageScore += pts;
            correctDuels++;
            if (pick.confidenceWeight === TOP_WEIGHT)
                topWeightHits++;
        }
    }
    return { stageScore, correctDuels, topWeightHits, scoreByDuel };
}
/** The maximum stage score: every duel called right, summed over the full ladder. */
export const MAX_STAGE_SCORE = CONFIG.CYCLING.CONFIDENCE_WEIGHTS.reduce((sum, w) => sum + applyDuelConfidence(CONFIG.CYCLING.POINTS.duel, w), 0);
//# sourceMappingURL=scoring.js.map